import React from 'react';

const ChevronDownIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'} strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path d="m6 9 6 6 6-6"/>
        </svg>
    );
};

export default ChevronDownIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/ChevronDownIcon.jsx